export default {
	isMobileOpen: false,
};
